<div *ngIf="isOpen" class="way-purchase-modal-overlay">
  <div
    class="way-purchase-modal-content"
    data-fs-unmask
    [@slideInOut]
    role="dialog"
    aria-modal="true"
    aria-labelledby="way-purchase-modal-title"
  >
    <div class="way-purchase-modal-header">
      <div class="way-purchase-modal-header__text">
        <h3 id="way-purchase-modal-title" class="way-purchase-modal-title">{{ getTitle() }}</h3>
      </div>
      <button
        type="button"
        class="way-purchase-modal-close"
        (click)="onCloseClick()"
        aria-label="Close"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <div class="way-purchase-modal-body">
      <app-way-purchase-single-wash-layout
        [notification]="notification"
        [needsPlateEntry]="needsPlateEntry"
        [plateInput]="plateInput"
        [plateInputError]="plateInputError"
        [plateInputDisabled]="isConfirming"
        (plateInputChange)="onPlateInputChange($event)"
      />
      <app-way-purchase-active-subscription-layout
        [notification]="notification"
        [needsPlateEntry]="needsPlateEntry"
        [plateInput]="plateInput"
        [plateInputError]="plateInputError"
        [plateInputDisabled]="isConfirming"
        (plateInputChange)="onPlateInputChange($event)"
      />
      <app-way-purchase-selection-layout
        [notification]="notification"
        [canceledOrderIds]="canceledOrderIds"
        [isBusy]="isConfirming"
        [activeCardId]="activeCardId"
        [cardErrors]="cardErrors"
        [cardPlateInputs]="cardPlateInputs"
        [plateInputDisabled]="isConfirming"
        (cardPlateInputChange)="onCardPlateInputChange($event)"
        (useOption)="onUseSelectionOption($event)"
        (cancelShopOption)="onCancelShopSelectionOption($event)"
      />
    </div>

    <div class="way-purchase-modal-footer-region">
      <div *ngIf="confirmError" class="way-purchase-modal-error">{{ confirmError }}</div>

      <div class="way-purchase-modal-footer">
        <button
          type="button"
          *ngIf="showCancelButton()"
          class="btn btn-secondary btn-large"
          [disabled]="isConfirming"
          (click)="onCloseClick()"
        >
          Cancel
        </button>

        <button
          type="button"
          *ngIf="showDismissButton()"
          class="btn btn-secondary btn-large"
          (click)="onDismissClick()"
        >
          {{ getDismissButtonLabel() }}
        </button>

        <button
          type="button"
          *ngIf="showConfirmButton()"
          class="btn btn-primary btn-large"
          [disabled]="isConfirmDisabled()"
          (click)="onConfirmClick()"
        >
          <span *ngIf="!isConfirming">{{ getConfirmButtonLabel() }}</span>
          <span *ngIf="isConfirming" class="loading-content">
            <div class="loading-spinner"></div>
            {{ getConfirmLoadingLabel() }}
          </span>
        </button>
      </div>
    </div>
  </div>
</div>
